import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, Clock } from "lucide-react";

function formatDate(iso) {
  const d = new Date(iso);
  return d.toLocaleDateString("en-IN", {
    day: "numeric",
    month: "short",
    year: "numeric",
  });
}

export default function NewsCard({ item, variant = "default" }) {
  const isFeatured = variant === "featured";

  return (
    <Link
      to={`/news/${item.slug}`}
      data-testid={`news-card-${item.slug}`}
      className={`group block ${
        isFeatured ? "md:grid md:grid-cols-12 md:gap-10 md:items-center" : ""
      }`}
    >
      <div
        className={`relative rounded-4xl overflow-hidden img-zoom bg-sageMist ${
          isFeatured ? "md:col-span-7 aspect-[16/10]" : "aspect-[4/3]"
        }`}
      >
        <img
          src={item.cover}
          alt={item.title}
          loading="lazy"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <span className="absolute top-4 left-4 inline-flex items-center px-3 py-1.5 rounded-full bg-bone/95 text-ink text-[10px] uppercase tracking-[0.22em] font-medium backdrop-blur-md">
          {item.category}
        </span>
        <span className="absolute top-4 right-4 inline-flex items-center justify-center h-10 w-10 rounded-full bg-ink text-bone opacity-0 group-hover:opacity-100 translate-x-1 group-hover:translate-x-0 transition-all duration-500">
          <ArrowUpRight className="h-4 w-4" />
        </span>
      </div>

      <div className={isFeatured ? "md:col-span-5 mt-6 md:mt-0" : "mt-5"}>
        <div className="flex items-center gap-3 text-[11px] uppercase tracking-[0.24em] text-muted">
          <span>{formatDate(item.date)}</span>
          <span className="h-1 w-1 rounded-full bg-muted" />
          <span className="inline-flex items-center gap-1.5">
            <Clock className="h-3 w-3" /> {item.readTime}
          </span>
        </div>
        <h3
          className={`font-display mt-3 text-ink leading-[1.05] tracking-tightest group-hover:text-coral transition-colors ${
            isFeatured ? "text-display-md" : "text-2xl md:text-[28px]"
          }`}
        >
          {item.title}
        </h3>
        <p className="mt-3 text-ink/65 leading-relaxed text-[15px] line-clamp-3">
          {item.dek}
        </p>
        <span className="link-underline inline-flex items-center gap-2 mt-5 text-sm font-medium text-ink">
          Read story <ArrowUpRight className="h-4 w-4" />
        </span>
      </div>
    </Link>
  );
}
